import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchController.php
* @route '/api/instant-search'
*/
const InstantSearchController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: InstantSearchController.url(options),
    method: 'get',
})

InstantSearchController.definition = {
    methods: ["get","head"],
    url: '/api/instant-search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchController.php
* @route '/api/instant-search'
*/
InstantSearchController.url = (options?: RouteQueryOptions) => {
    return InstantSearchController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchController.php
* @route '/api/instant-search'
*/
InstantSearchController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: InstantSearchController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InstantSearch\InstantSearchController::__invoke
* @see app/Http/Controllers/InstantSearch/InstantSearchController.php
* @route '/api/instant-search'
*/
InstantSearchController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: InstantSearchController.url(options),
    method: 'head',
})

export default InstantSearchController